"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "mediaPlayerSettings", {
  enumerable: true,
  get: function get() {
    return _mediaPlayerSettings["default"];
  }
});
var _mediaPlayerSettings = _interopRequireDefault(require("./mediaPlayerSettings"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }